import "./index.scss";
const H3 = ({ text }: { text: any }) => {
  return (
    <h3 className="title3" dangerouslySetInnerHTML={{ __html: text }}></h3>
  );
};

export default H3;
